import { render, staticRenderFns } from "./ConsultWorkersPage.vue?vue&type=template&id=63cd3abe"
import script from "./ConsultWorkersPage.vue?vue&type=script&lang=ts"
export * from "./ConsultWorkersPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultWorkersPage.vue?vue&type=style&index=0&id=63cd3abe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports